import { useAuth } from "@/context/AuthContext";

export function Topbar() {
  const { user, logout } = useAuth();
  const roleLabel = user?.role === "owner" ? "proprietario" : "staff";

  return (
    <header
      className="flex justify-end border-b border-slate-200 bg-white px-4 py-3 sm:px-8"
      data-testid="topbar-container"
    >
      <div className="flex w-full items-center justify-between gap-3 sm:w-auto sm:justify-end sm:gap-4">
        <div className="min-w-0 text-left sm:text-right">
          <p className="truncate text-sm font-medium" data-testid="topbar-user-name">
            {user?.name || "Titolare"}
          </p>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-400" data-testid="topbar-user-role">
            {roleLabel}
          </p>
        </div>
          <button
            onClick={logout}
            className="shrink-0 bg-slate-900 text-white px-3 py-2 sm:px-4 rounded-sm text-sm font-medium transition-transform active:scale-95"
            data-testid="logout-button"
          >
            Esci
          </button>
      </div>
    </header>
  );
}
